import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const QrCodeGenerator = () => {
  const authUser = getLoggedInUser();
  const orgData = authUser?.organizationInfo;
  const orgCode = authUser?.organizationInfo?.orgCode;
  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;

  const navigate = useNavigate();

  if (!url) {
    return <p>Please provide a valid URL.</p>;
  }

  const handleDownloadQR = () => {
    const canvas = document.getElementById("qr-canvas");
    if (canvas) {
      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `qr-code-${orgCode}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    // You can add a toast notification here
    alert("Link copied to clipboard!");
  };

  return (
    <Card className="" style={{ minHeight: "335px", borderRadius: "1rem" }}>
      <CardBody className="p-4">
        <div className="text-center">
          {/* QR Box - Reduced Padding & Margin */}
          <div
            className="d-inline-block p-3 rounded-3 mb-2"
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              border: "1px solid #e9ecef",
            }}
          >
            <QRCodeCanvas
              id="qr-canvas"
              value={url}
              size={150} // 🔥 Reduced from 200 → 140
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true} // 🔥 Remove extra spacing inside QR
            />
          </div>

          {/* URL Box - Reduced Padding */}
          <div
            className="d-flex align-items-center justify-content-center gap-2 p-2 rounded-3 mb-3"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
            }}
          >
            <i className="ri-link text-primary"></i>

            <Link
              to={url}
              target="_blank"
              className="text-decoration-none text-primary fw-medium"
              style={{ fontSize: "0.75rem" }}
            >
              {url}
            </Link>

            <button
              onClick={handleCopyLink}
              className="btn btn-sm btn-light border-0"
              style={{ padding: "0.15rem 0.4rem" }}
            >
              <i className="ri-file-copy-line"></i>
            </button>
          </div>

          <div className="d-flex justify-content-center gap-2 mb-2">
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center gap-1"
              onClick={() => navigate("/print-stand")}
            >
              <i className="ri-printer-line"></i>
              Print Stand
            </Button>

            <Button
              color="secondary"
              size="sm"
              className="d-flex align-items-center gap-1"
              onClick={() => navigate("/print-napkin")}
            >
              <i className="ri-printer-line"></i>
              Print Napkin
            </Button>
          </div>

          {/* Helper Text (Small Font) */}
          <p className="text-muted mb-0" style={{ fontSize: "0.7rem" }}>
            <i className="ri-information-line me-1"></i>
            Scan this QR code to access the menu
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

export default QrCodeGenerator;
